/** TouchScreenButton registration: the parser. Property knowledge lives in linterParser.ts. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseTouchScreenButton } from './parser';
const touchScreenButtonRegistration = {
    typeName: 'TouchScreenButton',
    parser: parseTouchScreenButton,
};
nodeRegistry.register(touchScreenButtonRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map